import React, { useState } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import {ReactComponent as ExpandMoreIcon} from '../assets/images/expand-more.svg';


const CAccordion = ({ title, children, expanded: expandedProp, ...accordionProps }) => {
  // Prefer the caller's expanded prop as the initial state (e.g. BudgetAllocation passes true).
  // Keep expand/collapse driven by local state so Accordion and AccordionDetails stay in sync.
  const [expanded, setExpanded] = useState(!!expandedProp);

  const handleIconClick = (event) => {
    event.stopPropagation();
    setExpanded((prev) => !prev);
  };

  return (
    <Accordion expanded={expanded} {...accordionProps}>
      <AccordionSummary
        component="div"
        aria-controls="panel-content"
        id="panel-header"
        sx={{ 
          display: 'flex', 
          alignItems: 'center',
          cursor: 'default',
          '&:hover': {
            backgroundColor: 'transparent',
          }
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <span
          role="button"
          tabIndex={0}
          onClick={handleIconClick}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              handleIconClick(e);
            }
          }}
          className="mr-2 min-w-0 min-h-0 cursor-pointer inline-flex items-center"
          aria-label={expanded ? 'Collapse' : 'Expand'}
        >
          <ExpandMoreIcon
            style={{
              transform: expanded ? 'rotate(90deg)' : 'rotate(0deg)',
              transition: 'transform 0.2s',
              cursor: 'pointer',
            }}
          />
        </span>
        <Typography component="div" sx={{ cursor: 'default', width: '100%' }}>{title}</Typography>
      </AccordionSummary>
      <AccordionDetails className={`${!expanded ? "hidden": null}`}>
        {children}
      </AccordionDetails>
    </Accordion>
  );
};

export default CAccordion;
